var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      staticStyle: { "margin-bottom": "20px" },
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " + _vm._s(_vm.$t("CustomerFunction.common.Returndetails")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("backText")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onDownload()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("labelDownloadText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.showLog } },
                [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseApplyDetail.operationLog"))
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      [
        _c(
          "el-row",
          [
            _c("div", { staticClass: "bj-row mt10 mb10" }, [
              _c("div", { staticClass: "bj-col-11" }, [
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(_vm._s(_vm.$t("billingPage.CustomerName"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.customName)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CustomerFunction.common.logisticsNo"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.logisticsNumber)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CustomerFunction.common.SubmissionTime"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm._f("timeFilters")(_vm.form.applyDate))),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "bj-col-1" }),
              _c("div", { staticClass: "bj-col-12" }, [
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(_vm._s(_vm.$t("CustomerFunction.common.Status"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          _vm.CSG_RETURN_LIST_ADMIN_CLOSE.bjGet(_vm.form.status)
                        )
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CustomerFunction.common.associatedCode"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.form.associatedCode)),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CustomerFunction.common.ConfirmTime"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm._f("timeFilters")(_vm.form.auditDate))),
                  ]),
                ]),
              ]),
            ]),
            _c("BjDivider", [
              _vm._v(_vm._s(_vm.$t("CustomerFunction.common.ApplicationList"))),
            ]),
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.form.applySkuList,
                  border: "",
                  script: "",
                  "max-height": "600",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("table.countText"),
                    type: "index",
                    width: "55",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "standardSkuCode",
                    label: "SKU",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "barCode",
                    label: _vm.$t("BusinessPurchaseDetailPage.table.Barcode"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "returnTotal",
                    label: _vm.$t("UploadTotalText"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "nonDefectiveHandling",
                    label: _vm.$t("CustomerFunction.table.GoodQuality"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  _vm.CSG_RETURN_LIST_ADMIN_STATUS.bjGet(
                                    row.nonDefectiveHandling
                                  )
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "defectiveHandling",
                    label: _vm.$t("CustomerFunction.table.HandlingOf"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  _vm.CSG_RETURN_LIST_ADMIN_STATUS.bjGet(
                                    row.defectiveHandling
                                  )
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm.form.confirmSkuList && _vm.form.confirmSkuList.length > 0
              ? [
                  _c("BjDivider", [
                    _vm._v(
                      _vm._s(_vm.$t("CustomerFunction.common.ConfirmList"))
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.form.confirmSkuList,
                        border: "",
                        script: "",
                        "max-height": "600",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("table.countText"),
                          type: "index",
                          width: "55",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "standardSkuCode",
                          label: "SKU",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "barCode",
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Barcode"
                          ),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "returnTotal",
                          label: _vm.$t("UploadTotalText"),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "nonDefectiveNumber",
                          label: _vm.$t("CustomerFunction.common.Quantityof"),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "nonDefectiveHandling",
                          label: _vm.$t("CustomerFunction.table.GoodQuality"),
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.CSG_RETURN_LIST_ADMIN_STATUS.bjGet(
                                            row.nonDefectiveHandling
                                          )
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2525281684
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "defectiveNumber",
                          label: _vm.$t(
                            "CustomerFunction.common.Quantityofdefective"
                          ),
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "defectiveHandling",
                          label: _vm.$t("CustomerFunction.table.HandlingOf"),
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.CSG_RETURN_LIST_ADMIN_STATUS.bjGet(
                                            row.defectiveHandling
                                          )
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1272040411
                        ),
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      _vm.form.materialList && _vm.form.materialList.length > 0
        ? [
            _c("BjDivider", [
              _vm._v(
                _vm._s(_vm.$t("CustomerFunction.common.AttachmentInformation"))
              ),
            ]),
            _c("div", { staticClass: "mt20" }, [
              _c(
                "div",
                { staticClass: "flex" },
                _vm._l(_vm.form.materialList, function (imageUrl, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "imageViewer" },
                    [
                      _c("BjKeyImage", {
                        staticStyle: { margin: "10px" },
                        attrs: {
                          height: "148px",
                          width: "148px",
                          url: _vm.normalizeDownloadUrl(imageUrl.detailImage),
                          preview: "",
                        },
                      }),
                      _c("div", { staticClass: "flex flex-spacearound" }, [
                        _c("i", {
                          staticClass: "el-icon-download yellow",
                          on: {
                            click: function ($event) {
                              return _vm.downloadImage(imageUrl.detailImage)
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }